<template>
    <content-view>
        <!-- 角色管理－新增角色权限 -->
        <div class="wrap-container-in">
            <div class="mb16">角色名称：
                <a-input placeholder="请输入角色名称" :disabled="disabledParent" style="width:400px" v-model="roleName"></a-input>
            </div>

            <!-- 角色权限 -->
            <div v-if="rolePermission.length > 0">
                <div class="mb16"> 角色权限: </div>
                <a-table class="mb16"
                    :columns="columns"
                    :dataSource="dataRole"
                    :loading="S_loading_fetch"
                    :pagination="pagination"
                    childrenColumnName="nochild"
                    :rowKey="(record,index) => index"
                    bordered>

                    <template slot-scope="text, record"
                        slot="name">
                        <a-checkbox v-if="!record._hidden"
                            :disabled="disabledParent"
                            :checked="record._originPermission._checkAll"
                            @change="onPermissionChange(record, $event, dataRole)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record"
                        slot="subPermission">
                        <a-checkbox :checked="record._checkAll" :disabled="record._disabled || disabledParent"
                            @change="onSubPermissionChange(record, $event)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record"
                        slot="children">
                        <a-checkbox-group :options="text" :disabled="record._subDisabled || disabledParent"
                            v-model="record._checkedList" />
                    </template>
                </a-table>
            </div>

            <!-- 后台管理权限 -->
            <div v-if="backendPermission.length > 0">
                <div class="mb16"> 角色后台权限: </div>
                <a-table class="mb16"
                    :columns="columns"
                    :dataSource="dataAdmin"
                    :loading="S_loading_fetch"
                    :pagination="pagination"
                    childrenColumnName="nochild"
                    :rowKey="(record,index) => index"
                    bordered>

                    <template slot-scope="text, record"
                        slot="name">
                        <a-checkbox v-if="!record._hidden"
                            :disabled="disabledParent"
                            :checked="record._originPermission._checkAll"
                            @change="onPermissionChange(record, $event, dataAdmin)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record"
                        slot="subPermission">
                        <a-checkbox :checked="record._checkAll" :disabled="record._disabled || disabledParent"
                            @change="onSubPermissionChange(record, $event)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record"
                        slot="children">
                        <a-checkbox-group :options="text" :disabled="record._subDisabled || disabledParent"
                            v-model="record._checkedList" />
                    </template>
                </a-table>
            </div>

            <!-- 新收银台权限 -->
            <div v-if="cashPayPermission.length > 0">
                <div class="mb16"> 新收银台权限: </div>
                <a-table
                    :columns="columns"
                    :dataSource="dataCashier"
                    :loading="S_loading_fetch"
                    :pagination="pagination"
                    childrenColumnName="nochild"
                    :rowKey="(record,index) => index"
                    bordered>

                    <template slot-scope="text, record"
                        slot="name">
                        <a-checkbox v-if="!record._hidden"
                            :disabled="disabledParent"
                            :checked="record._originPermission._checkAll"
                            @change="onPermissionChange(record, $event, dataCashier)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record"
                        slot="subPermission">
                        <a-checkbox :checked="record._checkAll" :disabled="record._disabled || disabledParent"
                            @change="onSubPermissionChange(record, $event)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record"
                        slot="children">
                        <a-checkbox-group :options="text" :disabled="record._subDisabled || disabledParent"
                            v-model="record._checkedList" />
                    </template>
                </a-table>
            </div>
            <!-- 积分管理系统权限 -->
            <div v-if="pointsPermission.length > 0">
                <div class="mb16 mt16"> 积分管理系统权限: </div>
                <a-table
                    :columns="columns"
                    :dataSource="dataPointsApp"
                    :loading="S_loading_fetch"
                    :pagination="pagination"
                    childrenColumnName="nochild"
                    :rowKey="(record,index) => index"
                    bordered>

                    <template slot-scope="text, record"
                        slot="name">
                        <a-checkbox v-if="!record._hidden"
                            :disabled="disabledParent"
                            :checked="record._originPermission._checkAll"
                            @change="onPermissionChange(record, $event, dataPointsApp)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record"
                        slot="subPermission">
                        <a-checkbox :checked="record._checkAll" :disabled="record._disabled || disabledParent"
                            @change="onSubPermissionChange(record, $event)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record"
                        slot="children">
                        <a-checkbox-group :options="text" :disabled="record._subDisabled || disabledParent"
                            v-model="record._checkedList" />
                    </template>
                </a-table>
            </div>
            <!-- 工作人员端权限 -->
            <!-- <div v-if="workerPermission.length > 0">
                <div class="mb16 mt16"> 工作人员APP权限: </div>
                <a-table
                    :columns="columns"
                    :dataSource="dataWorkApp"
                    :loading="S_loading_fetch"
                    :pagination="pagination"
                    childrenColumnName="nochild"
                    :rowKey="(record,index) => index"
                    bordered>

                    <template slot-scope="text, record"
                        slot="name">
                        <a-checkbox v-if="!record._hidden"
                            :disabled="disabledParent"
                            :checked="record._originPermission._checkAll"
                            @change="onPermissionChange(record, $event, dataWorkApp)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record"
                        slot="subPermission">
                        <a-checkbox :checked="record._checkAll" :disabled="record._disabled || disabledParent"
                            @change="onSubPermissionChange(record, $event)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record"
                        slot="children">
                        <a-checkbox-group :options="text" :disabled="record._subDisabled || disabledParent"
                            v-model="record._checkedList" />
                    </template>
                </a-table>
            </div> -->
            <!-- 新园管系统权限 -->
            <div v-if="h5WorkerPermission.length > 0">
                <div class="mb16 mt16"> 新园管系统权限: </div>
                <a-table
                    :columns="columns"
                    :dataSource="dataPointsH5App"
                    :loading="S_loading_fetch"
                    :pagination="pagination"
                    childrenColumnName="nochild"
                    :rowKey="(record,index) => index"
                    bordered>

                    <template slot-scope="text, record"
                        slot="name">
                        <a-checkbox v-if="!record._hidden"
                            :disabled="disabledParent"
                            :checked="record._originPermission._checkAll"
                            @change="onPermissionChange(record, $event, dataPointsH5App)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record"
                        slot="subPermission">
                        <!-- <a-radio v-if="text=='管理面板' || text=='餐饮工作面板' || text=='课程工作面板'"
                            :checked="record._checkAll" :disabled="record._disabled || disabledParent"
                            @change="onSubPermissionChange(record, $event, isRadio = true)">{{ text }}
                        </a-radio> -->
                        <a-checkbox :checked="record._checkAll" :disabled="record._disabled || disabledParent"
                            @change="onSubPermissionChange(record, $event)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record"
                        slot="children">
                        <a-checkbox-group :options="text" :disabled="record._subDisabled || disabledParent"
                            v-model="record._checkedList" />
                    </template>
                </a-table>
            </div>
            <!-- 游玩互动系统权限 -->
            <div v-if="playPermission.length > 0">
                <div class="mb16 mt16"> 游玩互动系统权限: </div>
                <a-table
                    :columns="columns"
                    :dataSource="dataPlay"
                    :loading="S_loading_fetch"
                    :pagination="pagination"
                    childrenColumnName="nochild"
                    :rowKey="(record,index) => index"
                    bordered>

                    <template slot-scope="text, record"
                        slot="name">
                        <a-checkbox v-if="!record._hidden"
                            :disabled="disabledParent"
                            :checked="record._originPermission._checkAll"
                            @change="onPermissionChange(record, $event, dataPlay)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record" slot="subPermission">
                        <a-checkbox :checked="record._checkAll" :disabled="record._disabled || disabledParent"
                            @change="onSubPermissionChange(record, $event)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record"
                        slot="children">
                        <a-checkbox-group :options="text" :disabled="record._subDisabled || disabledParent"
                            v-model="record._checkedList" />
                    </template>
                </a-table>
            </div>
            <!-- BI系统权限 -->
            <!-- <div v-if="biPermission.length > 0">
                <div class="mb16 mt16"> bi系统权限: </div>
                <a-table
                    :columns="columns"
                    :dataSource="dataBi"
                    :loading="S_loading_fetch"
                    :pagination="pagination"
                    childrenColumnName="nochild"
                    :rowKey="(record,index) => index"
                    bordered>

                    <template slot-scope="text, record"
                        slot="name">
                        <a-checkbox v-if="!record._hidden"
                            :disabled="disabledParent"
                            :checked="record._originPermission._checkAll"
                            @change="onPermissionChange(record, $event, dataBi)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record"
                        slot="subPermission">
                        <a-checkbox :checked="record._checkAll" :disabled="record._disabled || disabledParent"
                            @change="onSubPermissionChange(record, $event)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record"
                        slot="children">
                        <a-checkbox-group :options="text" :disabled="record._subDisabled || disabledParent"
                            v-model="record._checkedList" />
                    </template>
                </a-table>
            </div> -->
            <!-- 租赁管理系统权限 -->
            <div v-if="leasePermission.length > 0">
                <div class="mb16 mt16"> 租赁管理系统权限: </div>
                <a-table
                    :columns="columns"
                    :dataSource="dataLease"
                    :loading="S_loading_fetch"
                    :pagination="pagination"
                    childrenColumnName="nochild"
                    :rowKey="(record,index) => index"
                    bordered>

                    <template slot-scope="text, record"
                              slot="name">
                        <a-checkbox v-if="!record._hidden"
                                    :disabled="disabledParent"
                                    :checked="record._originPermission._checkAll"
                                    @change="onPermissionChange(record, $event, dataLease)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record" slot="subPermission">
                        <a-checkbox :checked="record._checkAll" :disabled="record._disabled || disabledParent"
                                    @change="onSubPermissionChange(record, $event)">{{ text }}</a-checkbox>
                    </template>

                    <template slot-scope="text, record"
                              slot="children">
                        <a-checkbox-group :options="text" :disabled="record._subDisabled || disabledParent"
                                          v-model="record._checkedList" />
                    </template>
                </a-table>
            </div>
        </div>
        <div slot="footer" class="pr24 pt8 pb8">
            <a-button @click="$router.go(-1)">取消</a-button>
            <a-button type="primary"
                      v-if="$route.name !== 'detailRole'"
                      :loading="S_loading_submit"
                      @click="saveSetting">保存</a-button>
        </div>
    </content-view>
</template>
<script type="text/ecmascript-6">
    // const fakeData = [
    //     {
    //         id: 1,
    //         name: '订单管理',
    //         status: 1,
    //         children: [
    //             {
    //                 name: '订单列表',
    //                 children: []
    //             },
    //             {
    //                 id: 11,
    //                 name: '售后列表',
    //                 status: 1,
    //                 children: [{ name: '启用列表', status: 1 }]
    //             },
    //             {
    //                 id: 12,
    //                 name: '售后原因列表',
    //                 status: 0,
    //                 children: [{ name: '退货原因设置' }, { name: '添加原因' }, { name: '编辑原因' }, { name: '删除原因' }]
    //             }
    //         ],
    //     },
    //     {
    //         id: 2,
    //         name: '商品管理',
    //         status: 0,
    //         children: [
    //             {
    //                 id: 13,
    //                 name: '商品类目',
    //                 status: 1,
    //                 children: [{ name: '编辑类目', status: 1 }, { name: '删除类目', status: 1 }]
    //             },
    //             {
    //                 id: 14,
    //                 name: '商品规格',
    //                 status: 1,
    //                 children: [{ name: '添加规格', status: 1 }, { name: '编辑规格', status: 1 }, { name: '删除规格', status: 1 }]
    //             }
    //         ],
    //     },
    // ];

    // 初次整理后的数据结构
    // [
    //     { id: 1, name: '订单管理', subPermission: '售后列表', children: [{ name: '启用列表' }] },
    //     { id: 1, name: '订单管理', subPermission: '退货原因设置', children: [{ name: '退货原因设置' }, { name: '添加原因' }, { name: '编辑原因' }, { name: '删除原因' }] },
    //     { id: 2, name: '商品管理', subPermission: '商品类目', children: [{ name: '编辑类目' }, { name: '删除类目' }] },
    //     { id: 2, name: '商品管理', subPermission: '商品规格', children: [{ name: '添加规格' }, { name: '编辑规格' }, { name: '删除规格' }] },
    // ]

    // 程序判断需要的额外字段
    // see runtime and below functions

    let _lastPermissionId;
    const MOCK_CHECKED_EVENT = { target: { checked: true } };
    import { mapGetters } from "vuex";

    export default {
        name: 'AuthSettingPage',
        zh: '部门管理-权限设置页面',
        props: {
            roleId: [Number, String]
        },
        filters: {
            booleanfy(value) {
                return Boolean(value);
            }
        },
        data() {
            return {
                S_loading_fetch: false,
                S_loading_submit: false,
                allChecked: false,
                disabledParent: false,
                columns: [
                    {
                        title: '模块',
                        width: "160px",
                        dataIndex: 'name',
                        scopedSlots: { customRender: 'name' },
                    },
                    {
                        title: '子模块',
                        width: "180px",
                        dataIndex: 'subPermission',
                        scopedSlots: { customRender: 'subPermission' },
                    },
                    {
                        title: '功能',
                        dataIndex: 'children',
                        scopedSlots: { customRender: 'children' },
                    }
                ],
                dataRole: [],
                dataAdmin: [],
                dataCashier: [],
                dataPointsApp: [],
                dataPointsH5App: [],
                dataWorkApp: [],
                dataBi: [],
                dataPlay: [],
                dataLease: [],

                rolePermission: [],
                backendPermission: [],
                cashPayPermission: [],
                pointsPermission: [],
                h5WorkerPermission: [],
                workerPermission: [],
                playPermission: [],
                biPermission: [],
                leasePermission: [],
                pagination: false,
                roleName: '',
                editIds: [],
                id: ''
            }
        },
        computed: {
            ...mapGetters(["shopId"])

        },
        created() {
            this.id = this.$route.query.id
            // this.$route.query.edit ? this.getDetail() : this.getAuthSetting()
            this.disabledParent = this.$route.name === 'detailRole'
            this.$route.name !== 'addRole' ? this.getDetail() : this.getAuthSetting()
        },
        mounted() {},
        methods: {
            // 获取设置
            getAuthSetting() {
                this.S_loading_fetch = true;
                this.$api.jurisdiction.allPermission().then(res => {
                        const rolePermission = res.rolePermission;
                        const backendPermission = res.backendPermission;
                        const cashPayPermission = res.cashPayPermission;
                        const h5WorkerPermission = res.h5WorkerPermission;
                        const pointsPermission = res.pointsPermission;
                        const workerPermission = res.workerPermission;
                        const biPermission = res.biPermission;
                        const playPermission = res.playPermission;
                        const leasePermission = res.leasePermission;
                        this.processData(rolePermission).then(data => {
                            this.dataRole = data;
                            this.rolePermission = rolePermission;
                        });
                        this.processData(backendPermission).then(data => {
                            this.dataAdmin = data;
                            this.backendPermission = backendPermission;
                        });
                        this.processData(cashPayPermission).then(data => {
                            this.dataCashier = data;
                            this.cashPayPermission = cashPayPermission;
                        });
                        this.processData(h5WorkerPermission).then(data => {
                            this.dataPointsH5App = data;
                            this.h5WorkerPermission = h5WorkerPermission;
                        });
                        this.processData(pointsPermission).then(data => {
                            this.dataPointsApp = data;
                            this.pointsPermission = pointsPermission;
                        });
                        this.processData(workerPermission).then(data => {
                            this.dataWorkApp = data;
                            this.workerPermission = workerPermission;
                        });
                        this.processData(biPermission).then(data => {
                            this.dataBi = data;
                            this.biPermission = biPermission;
                        });
                        this.processData(playPermission).then(data => {
                            this.dataPlay = data;
                            this.playPermission = playPermission;
                        });
                        this.processData(leasePermission).then(data => {
                            this.dataLease = data;
                            this.leasePermission = leasePermission;
                        });
                        this.S_loading_fetch = false;
                    }).catch(err => {
                        this.S_loading_fetch = false;
                    })
            },

            // 获取设置编辑详情
            getDetail() {
                this.$api.jurisdiction.getDetail({
                    params: {
                        id: this.id
                    }
                }).then(res => {
                    this.roleName = res.roleName;
                    this.editIds = res.permissionList.map(i => i.id);
                    this.getAuthSetting();
                }).catch(err => {
                    console.error(err);
                })
            },

            // 提交
            saveSetting() {
                const pkg0 = this.getPackagedData(this.dataRole);
                const pkg = this.getPackagedData(this.dataAdmin);
                const pkg1 = this.getPackagedData(this.dataCashier);
                const pkg2 = this.getPackagedData(this.dataPointsApp);
                const pkg3 = this.getPackagedData(this.dataPointsH5App);
                const pkg4 = this.getPackagedData(this.dataWorkApp);
                const pkg5 = this.getPackagedData(this.dataBi);
                const pkg6 = this.getPackagedData(this.dataPlay);
                const pkg7 = this.getPackagedData(this.dataLease);
                const selectedPermissions = pkg0.concat(pkg,pkg1,pkg2,pkg3,pkg4,pkg5,pkg6,pkg7)
                if (this.roleName === '') {
                    this.$message.warning('请输入角色名称', 3);
                    this.S_loading_submit = false;
                    return;
                }
                if (selectedPermissions.length === 0) {
                    this.$message.warning('请至少选择一项权限', 3);
                    this.S_loading_submit = false;
                    return;
                }
                let flagList = []
                selectedPermissions.indexOf('658') > 0 && flagList.push('658');
                selectedPermissions.indexOf('659') > 0 && flagList.push('659');
                selectedPermissions.indexOf('660') > 0 && flagList.push('660');
                if (flagList.length > 1) {
                    this.$message.warning('工作人员APP权限：首页->管理面板、餐饮工作面板、课程工作面板至多选择一项', 3);
                    this.S_loading_submit = false;
                    return;
                }
                let flagListNew = []
                selectedPermissions.indexOf('637') > 0 && flagListNew.push('637');
                selectedPermissions.indexOf('638') > 0 && flagListNew.push('638');
                selectedPermissions.indexOf('639') > 0 && flagListNew.push('639');
                if (flagListNew.length > 1) {
                    this.$message.warning('新园管系统权限：首页->管理面板、餐饮工作面板、课程工作面板至多选择一项', 3);
                    this.S_loading_submit = false;
                    return;
                }
                this.S_loading_submit = true;
                this.$api.jurisdiction[this.$route.query.edit ? 'updateRole' : 'addRole']({
                        body: {
                            roleName: this.roleName,
                            id: this.id,
                            shopId: this.shopId,
                            permissionIdList: selectedPermissions
                        }
                    })
                    .then(res => {
                        this.$message.success('操作成功');

                        this.S_loading_submit = false;
                        this.$router.go(-1);
                    })
                    .catch(err => {
                        this.S_loading_submit = false;
                    })
            },

            // 处理数据
            processData(data) {
                return Promise.resolve(data)
                    .then(this._preProcessData)
                    .then(this._processRenderData)
            },

            // 初次整理基础数据结构
            _preProcessData(data) {
                return new Promise(resolve => {
                    const subPermissions = [];
                    data.forEach(perm => {
                        perm._checkAll = false;
                        perm._checkedList = [];
                        perm.childList.forEach(subPerm => {
                            const subPermission = {
                                id: perm.id,
                                subId: subPerm.id,
                                name: perm.name,
                                subPermission: subPerm.name,
                                _disabled: true,
                                _subDisabled: true,
                                children: subPerm.childList ? subPerm.childList.map(child => {
                                    return Object.assign({}, child, {
                                        label: child.name,
                                        value: child.id,
                                        status: child.status
                                    })
                                }) : [],
                                // 保留对原始模块的引用
                                _originPermission: perm,
                                _originSubPermission: subPerm,
                            };
                            // 新增对解析之后模块的引用
                            subPerm._parsedPermission = subPermission;
                            subPermissions.push(subPermission);
                        });
                    });
                    resolve(subPermissions);
                });
            },

            // 处理 table 渲染所需数据
            _processRenderData(subPermissions) {
                return new Promise(resolve => {
                    const subPerms = subPermissions.map(subPermission => {
                        subPermission._checkAll = false;
                        subPermission._checkedList = [];
                        // 判断当前 permission名称显示
                        if (_lastPermissionId !== subPermission.id) {
                            _lastPermissionId = subPermission.id;
                            subPermission._hidden = false;
                        }else {
                            subPermission._permission_BK = subPermission.name;
                            subPermission._hidden = true;
                            subPermission.name = '';
                        }

                        const originSubPerm = subPermission._originSubPermission;
                        if (originSubPerm.status) {
                            this.onSubPermissionChange(subPermission, MOCK_CHECKED_EVENT);
                        }
                        // 详情，编辑时回填
                        if(this.$route.name !== 'addRole') {
                            this.editIds.forEach(item => {
                                if(item === subPermission.id) {
                                    subPermission._originPermission._checkAll = true
                                    subPermission._disabled = false
                                }
                                if(item === subPermission.subId) {
                                    subPermission._checkAll = true
                                    subPermission._subDisabled = false
                                }
                                if (subPermission._originSubPermission.childList) {
                                    subPermission._originSubPermission.childList.forEach(perm => {
                                        if(item === perm.id) {
                                            subPermission._checkedList.push(item)
                                        }
                                    })
                                }
                            })
                        }
                        return subPermission;
                    });

                    this.rolePermission.forEach(perm => {
                        // 处理初始选中的值
                        if (perm.status) {
                            this.onPermissionChange({ _originPermission: perm }, MOCK_CHECKED_EVENT, this.dataRole, true);
                        }
                    });
                    this.backendPermission.forEach(perm => {
                        // 处理初始选中的值
                        if (perm.status) {
                            this.onPermissionChange({ _originPermission: perm }, MOCK_CHECKED_EVENT, this.dataAdmin, true);
                        }
                    });
                    this.cashPayPermission.forEach(perm => {
                        // 处理初始选中的值
                        if (perm.status) {
                            this.onPermissionChange({ _originPermission: perm }, MOCK_CHECKED_EVENT, this.dataCashier, true);
                        }
                    });
                    this.pointsPermission.forEach(perm => {
                        // 处理初始选中的值
                        if (perm.status) {
                            this.onPermissionChange({ _originPermission: perm }, MOCK_CHECKED_EVENT, this.dataPointsApp, true);
                        }
                    });
                    this.h5WorkerPermission.forEach(perm => {
                        // 处理初始选中的值
                        if (perm.status) {
                            this.onPermissionChange({ _originPermission: perm }, MOCK_CHECKED_EVENT, this.dataPointsH5App, true);
                        }
                    });
                    this.workerPermission.forEach(perm => {
                        // 处理初始选中的值
                        if (perm.status) {
                            this.onPermissionChange({ _originPermission: perm }, MOCK_CHECKED_EVENT, this.dataWorkApp, true);
                        }
                    });
                    this.biPermission.forEach(perm => {
                        // 处理初始选中的值
                        if (perm.status) {
                            this.onPermissionChange({ _originPermission: perm }, MOCK_CHECKED_EVENT, this.dataBi, true);
                        }
                    });
                    this.playPermission.forEach(perm => {
                        // 处理初始选中的值
                        if (perm.status) {
                            this.onPermissionChange({ _originPermission: perm }, MOCK_CHECKED_EVENT, this.dataPlay, true);
                        }
                    });
                    this.leasePermission.forEach(perm => {
                        // 处理初始选中的值
                        if (perm.status) {
                            this.onPermissionChange({ _originPermission: perm }, MOCK_CHECKED_EVENT, this.dataLease, true);
                        }
                    });

                    resolve(subPerms);
                })
            },

            // 当主模块发生变化
            onPermissionChange(subPermission, ev, data, isPassive = true, cascade = false) {
                const checked = ev.target.checked;
                const perm = subPermission._originPermission;
                const checkedList = subPermission._originPermission._checkedList;

                Object.assign(perm, {
                    _checkAll: checked,
                });

                data.forEach(item => {
                    if(item.id === subPermission.id) {
                        // 控制子模块
                        item._disabled = !checked
                        item._checkAll = false
                        item._checkedList = []
                        if(!checked) {
                            // 如果未选中主模块 则清空所有已选中的子模块和功能，并禁用他们
                            item._subDisabled = true
                        }
                    }
                })
            },

            // 当子模块发生变化
            // isPassive 是否是被动调用的（响应事件）
            onSubPermissionChange(subPermission, ev, isPassive = true) {
                const checked = ev.target.checked;
                const checkedList = subPermission._checkedList;

                Object.assign(subPermission, {
                    // 控制 children
                    _checkAll: checked,
                });
                if(checked) {
                    subPermission._subDisabled = false
                }else {
                    // 如果未选中主模块 则清空所有已选中的功能，并禁用他们
                    subPermission._checkedList = []
                    subPermission._subDisabled = true
                }
            },

            // 获取封装好准备提交的数据
            getPackagedData(data) {
                let selectedPermissions = []
                data.forEach(item => {
                    // 一级选中菜单id
                    if(item._originPermission._checkAll && !item._hidden) {
                        selectedPermissions.push(item.id)
                    }
                    // 二级选中菜单id
                    if(item._checkAll) {
                        selectedPermissions.push(item.subId)
                    }
                    // 三级选中菜单id
                    selectedPermissions = selectedPermissions.concat(item._checkedList)
                })

                return selectedPermissions;
            }
        },

    }
</script>

<style lang="scss">

</style>
